import { useParams, useLocation, matchPath } from "react-router-dom";
import { useEffect } from "react";
import { allowedOrgIds } from "../utils/orgIdMap";
import { AuthApiService } from "../service/authService";

const useFetchOrgId = () => {
  const params = useParams();
  const location = useLocation(); // Get the current path
  const matchParams = matchPath({ path: "/:orgId/*" }, location.pathname);

  const orgId = params?.orgId ?? matchParams?.params.orgId ?? "";

  if (!allowedOrgIds.includes(orgId) && orgId !== "") {
    AuthApiService.logout();
    window.location.pathname = "/";
    alert("Org Id is not allowed, Please enter valid Org Id");
  }

  useEffect(() => {
    if (orgId) {
      localStorage.setItem("orgId", orgId);
    }
  }, [orgId, location.pathname]);

  return null;
};

export default useFetchOrgId;
